<template>

    <div class="dd-m-graphic dd-m-graphic--radial">
        <div class="dd-m-graphic--radial__content">
            <div class="dd-m-graphic--radial__chart">
                <apexchart type=radialBar height=220 width=150 :options="chartOptions" :series="series"/>
            </div>

            <div class="dd-m-graphic--radial__legend">
                <ul class="dd-m-graphic__list">
                    <li class="dd-m-graphic__radial-item" v-for="(subitem, index) in item.values" :key="index">
                        {{subitem.label}}
                        <i class="dd-m-icon icon-question dd-m-tooltip"
                           v-tooltip.top-center="{content: subitem.tooltip, offset: '5',
                   trigger: 'hover click focus', classes: 'dd-m-tooltip--centered'}"></i>
                    </li>
                </ul>
            </div>
        </div>
    </div>

</template>
<script>
    import VueApexCharts from 'vue-apexcharts';
    import ChartOptions from '../../providers/chart';
    import VTooltip from 'v-tooltip';

    window.Vue.use(VTooltip);
    window.Vue.component('apexchart', VueApexCharts);

    const customChartOptions = new ChartOptions();

    export default {
        name: 'graphic-radial',
        props: ['item'],
        data() {
            return {
                series: [],
                chartOptions: customChartOptions.getRadial()
            }
        },
        mounted() {
            this.series = this.item.values.map((item) => item.value);
            this.chartOptions.labels = this.item.values.map((item) => item.label);
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/graphics/graphic-radial.vue